import React from 'react';
import Barcode from 'react-barcode';
// @ts-ignore
import styles from './PatientManualRegistrationMOU.module.scss';
import useTranslation from '../../../../../../Hooks/useTranslation';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';
import MagicForm from '../../../../../../Components/Form/MagicForm';

export interface PatientManualRegistrationMOUStep2Values {
	printCheck: boolean;
	emailCheck: boolean;
	email?: string;
	phoneCheck: boolean;
	phone?: string;
}

interface Props {
	mouNumber: string;
	onSuccess: (values: PatientManualRegistrationMOUStep2Values) => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.CHECKBOX,
		key: 'printCheck',
		title: 'component.patientRegistrationStep2.printRegistrationCode',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'emailCheck',
		title: 'component.patientRegistrationStep2.sendCodeToEmail',
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'emailCheck',
					rule: 'equal',
					value: true,
				},
			],
		},
		subType: 'view',
		children: [
			{
				type: MagicField.CONTAINER,
				settings: {
					showLine: true,
				},
				children: [
					{
						type: MagicField.EMAIL,
						key: 'email',
						settings: {
							required: true,
							errorMessage:
								'validation.patientManualRegistrationMOUStep2.email',
						},
					},
				],
			},
		],
	},
	{
		type: MagicField.CHECKBOX,
		key: 'phoneCheck',
		title: 'component.patientRegistrationStep2.sendCodeToPhone',
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'phoneCheck',
					rule: 'equal',
					value: true,
				},
			],
		},
		subType: 'view',
		children: [
			{
				type: MagicField.CONTAINER,
				settings: {
					showLine: true,
				},
				children: [
					{
						type: MagicField.PHONE_NUMBER,
						key: 'phone',
						settings: {
							required: true,
							errorMessage:
								'validation.patientManualRegistrationMOUStep2.phone',
						},
					},
				],
			},
		],
	},
];

const PatientManualRegistrationMOUStep2: React.FC<Props> = ({
	mouNumber,
	onSuccess,
}) => {
	const { t } = useTranslation();

	const handleSubmit = (values: any) => {
		onSuccess(values as PatientManualRegistrationMOUStep2Values);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.barcodeWrapper}>
				<Barcode value={mouNumber} width={4} />
			</div>
			<div className={styles.title}>{t('base.shared.pleasePick')}:</div>
			<MagicForm formScheme={formScheme} onSubmit={handleSubmit} />
		</div>
	);
};

export default PatientManualRegistrationMOUStep2;
